export default function formatValorBonus(valor_bonus) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(valor_bonus);
}
